export default "__VITE_ASSET__5277203f__"